{
  "GenericScopeTab_CME": "CME",
  "GenericScopeTab_Telsys": "Telephony Server",
  "GenericScopeTab_Telsys_Required": "Telephony Server is required",
  "GenericScopeTab_Partition": "Partition",
  "GenericScopeTab_Device": "Device",
  "GenericScopeTab_FilterRecursive": "Filter Recursively",
  "NAME": "GenericScopeTab"
}